import type { StrapiArrayResponse, StrapiSingleResponse } from '@/types/common/api'
import maxios from '@/utils/axios/maxios'
import strapi from '@/utils/axios/strapi'

// 공지 API
const noticeApi = {
  /* 매쓰플랫-기관*/
  // 공지(기관) 가져오기
  async getAcademies(params) {
    const res = await strapi.get<StrapiArrayResponse<res.AcademyNotice>>(`/scienceflat-notices`, {
      params: {
        ...params,
      },
    })
    return res.data
  },
  // 알림판
  getNoticeBoard: async (params) => {
    return await strapi.get<StrapiArrayResponse<res.NoticeBoard>>('/scienceflat-notices-board', {
      params: {
        ...params,
      },
    })
  },

  // 온보딩 팝업
  getOnboardingPopup: async (params) => {
    return await strapi.get<StrapiArrayResponse<res.OnboardingPopup>>(
      '/mathflat-onboarding-popups',
      {
        params,
      },
    )
  },
  async getBanner(params) {
    return await strapi.get<StrapiArrayResponse<res.Banner>>('/mathflat-banners', { params })
  },

  // 서버 점검 페이지 가져오기 (사이언스플랫 전용 single type — 매쓰플랫의 /server-maintenance 와 분리)
  async getServerMaintenanceNotice() {
    return await strapi.get<StrapiSingleResponse<res.ServerMaintenance>>(
      '/scienceflat-server-maintenance',
    )
  },
}
export default noticeApi
